import { WebRTCPlayer } from '../src/index';
window.WebRTCPlayer = WebRTCPlayer;